var weather = (function(){
	function init() {
		initSelectorWrap();
		initLazy();
		initMultiSelect();
	}
	function initSelectorWrap() {
		var wrap = document.getElementById('weatherStationWrap');
		if (!wrap) return;
		var selector = wrap.querySelector('select.selector');
		if (!selector) return;
		var url = selector.dataset.url;
		var target = wrap.querySelector('.target');
		if (!url || !target) return;

		function change() {
			var selectedId = parseInt(selector.options[selector.selectedIndex].value);
			var fetchUrl = url + "/" + selectedId;
			fetchAndReplace(fetchUrl, target);
		}
		selector.addEventListener('change', change, false);
		change();
	}
	function fetchAndReplace(url, target) {
		var headers = new Headers();
		headers.append('X-Requested-With', 'XMLHttpRequest');
		var options = {
			credentials: 'include',
			headers: headers
		};
		fetch(url, options).then(function(response){
			if (!response.ok) {
				return '-';
			}
			return response.text();
		}).then(function(text) {
			target.innerHTML = text;
		});
	}
	function initLazy() {
		var wraps = document.querySelectorAll('.weather_lazy');
		for (var i = 0; i < wraps.length; i++) {
			var url = wraps[i].dataset.url;
			if (url) {
				fetchAndReplace(url, wraps[i]);
			}
		}
	}
	function initMultiSelect() {
		var $weatherMulti = $('.weatherElm');
		if ($weatherMulti.find('#weatherStationSelect').length === 0) return false;
		var $first = $weatherMulti.find('.weatherData:first-child');
		$first.addClass('selected');
		$('#weatherStationSelect').change(function() {
			$weatherMulti.removeClass('showDefault');
			var $location = $('.weatherData[id*="' + $(this).val() +  '"]');
			$location.addClass('selected');
			$location.siblings().removeClass('selected');
			// mWeather can be defined in site.js, to handle mobile weather update
			if (site.weather.mWeather) {
				site.weather.mWeather();
			}
		});
	}
	init();
})();
